import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useContentPageTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
